export enum PermissionLevel {
  OWNER = 'owner_moderator',
  ORGANIZER = 'organizer',
  USER = 'user',
}

export enum UsageLevel {
  CHANNEL = 'Channel',
  SERVER = 'Server',
  EVENTS = 'Event',
  STUFF = 'Stuff',
  USER = 'User',
  TEMPLATE = 'Template',
  GEARS = 'Gears',
  PATREON = 'Patreon',
  REPEATING_EVENTS = 'Repeating_Events',
}

export interface Command {
  permission: PermissionLevel;
  usage_type: UsageLevel;

  command: string;
  description: string;
  usage: string;
  example: string;
  help: string;
}
